module.exports = __webpack_public_path__ + "img/515.7130a5b9.png";